module.exports = __webpack_public_path__ + "img/24_63.8f595c3a.png";